import React, { useEffect, useRef } from "react";

import PropTypes from "prop-types";

import { ReactComponent as AstronautIcon } from "../../../assets/icons/astronaut.svg";
import { ReactComponent as BookmarkEarnedIcon } from "../../../assets/icons/bookmark-earned.svg";
import { ReactComponent as BookmarkIcon } from "../../../assets/icons/bookmark.svg";
import { ReactComponent as BookmarksIcon } from "../../../assets/icons/bookmarks.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar.svg";
import { ReactComponent as CelebrationIcon } from "../../../assets/icons/celebration.svg";
import { ReactComponent as ChallengeIcon } from "../../../assets/icons/challenge.svg";
import { ReactComponent as Check1Icon } from "../../../assets/icons/check1.svg";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check.svg";
import { ReactComponent as CheckErrorIcon } from "../../../assets/icons/check_error.svg";
import { ReactComponent as CheckListIcon } from "../../../assets/icons/check_list.svg";
import { ReactComponent as CheckProgressIcon } from "../../../assets/icons/check_progress.svg";
import { ReactComponent as CircleIcon } from "../../../assets/icons/circle.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { ReactComponent as CloseSeason } from "../../../assets/icons/close_season.svg";
import { ReactComponent as CloseType1Icon } from "../../../assets/icons/close_type1.svg";
import { ReactComponent as DestinationIcon } from "../../../assets/icons/destination.svg";
import { ReactComponent as DirectionIcon } from "../../../assets/icons/direction.svg";
import { ReactComponent as DocumentReviewIcon } from "../../../assets/icons/document-review.svg";
import { ReactComponent as DownChevronIcon } from "../../../assets/icons/down_chevron.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/download.svg";
import { ReactComponent as FastforwardIcon } from "../../../assets/icons/fast_forward.svg";
import { ReactComponent as CSVIcon } from "../../../assets/icons/file/csv.svg";
import { ReactComponent as DOCXIcon } from "../../../assets/icons/file/docx.svg";
import { ReactComponent as MP4Icon } from "../../../assets/icons/file/mp4.svg";
import { ReactComponent as MPEGIcon } from "../../../assets/icons/file/mpeg.svg";
import { ReactComponent as PDFIcon } from "../../../assets/icons/file/pdf.svg";
import { ReactComponent as PPTIcon } from "../../../assets/icons/file/ppt.svg";
import { ReactComponent as XSLIcon } from "../../../assets/icons/file/xsl.svg";
import { ReactComponent as HideIcon } from "../../../assets/icons/hide.svg";
import { ReactComponent as HomeIcon } from "../../../assets/icons/home.svg";
import { ReactComponent as InvisibleIcon } from "../../../assets/icons/invisible.svg";
import { ReactComponent as JourneyAvatar } from "../../../assets/icons/journey_avatar.svg";
import { ReactComponent as LeftArrow } from "../../../assets/icons/left_arrow.svg";
import { ReactComponent as LeftChevronIcon } from "../../../assets/icons/left_chevron.svg";
import { ReactComponent as LessonIcon } from "../../../assets/icons/lesson.svg";
import { ReactComponent as LevelDeliverableIcon } from "../../../assets/icons/level_deliverable.svg";
import { ReactComponent as LevelObject } from "../../../assets/icons/level_object.svg";
import { ReactComponent as LevelProgressReportIcon } from "../../../assets/icons/level_progress_report.svg";
import { ReactComponent as LevelRecapIcon } from "../../../assets/icons/level_recap.svg";
import { ReactComponent as LinkIcon } from "../../../assets/icons/link.svg";
import { ReactComponent as LowVolumnIcon } from "../../../assets/icons/low_volumn.svg";
import { ReactComponent as MagicWandIcon } from "../../../assets/icons/magic_wand.svg";
import { ReactComponent as MaximizeIcon } from "../../../assets/icons/maximize.svg";
import { ReactComponent as MirrorIcon } from "../../../assets/icons/mirror.svg";
import { ReactComponent as MuteIcon } from "../../../assets/icons/mute.svg";
import { ReactComponent as NextIcon } from "../../../assets/icons/next.svg";
import { ReactComponent as NotificationIcon } from "../../../assets/icons/notification.svg";
import { ReactComponent as OpenSeason } from "../../../assets/icons/open_season.svg";
import { ReactComponent as PadlockIcon } from "../../../assets/icons/padlock.svg";
import { ReactComponent as PadlockUnlock } from "../../../assets/icons/padlock_unlock.svg";
import { ReactComponent as PauseIcon } from "../../../assets/icons/pause.svg";
import { ReactComponent as PenIcon } from "../../../assets/icons/pen.svg";
import { ReactComponent as PendingIcon } from "../../../assets/icons/pending.svg";
import { ReactComponent as PerformanceIcon } from "../../../assets/icons/performance.svg";
import { ReactComponent as PicturePlaceholderIcon } from "../../../assets/icons/picture_placeholder.svg";
import { ReactComponent as PlayIcon } from "../../../assets/icons/play.svg";
import { ReactComponent as PodiumIcon } from "../../../assets/icons/podium.svg";
import { ReactComponent as PreviousIcon } from "../../../assets/icons/previous.svg";
import { ReactComponent as ProcessIcon } from "../../../assets/icons/process.svg";
import { ReactComponent as ProvideFeedbackIcon } from "../../../assets/icons/provide_feedback.svg";
import { ReactComponent as QuestionIcon } from "../../../assets/icons/question.svg";
import { ReactComponent as RatingIcon } from "../../../assets/icons/Rating.svg";
import { ReactComponent as RefreshIcon } from "../../../assets/icons/refresh.svg";
import { ReactComponent as RewindIcon } from "../../../assets/icons/rewind.svg";
import { ReactComponent as RightArrowRedIcon } from "../../../assets/icons/right_arrow.svg";
import { ReactComponent as RightArrowWhiteIcon } from "../../../assets/icons/right_arrow_white.svg";
import { ReactComponent as RightChevronIcon } from "../../../assets/icons/right_chevron.svg";
import { ReactComponent as SearchIcon } from "../../../assets/icons/search.svg";
import { ReactComponent as SendMailIcon } from "../../../assets/icons/send_mail.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/icons/settings.svg";
import { ReactComponent as Share } from "../../../assets/icons/share.svg";
import { ReactComponent as ShowIcon } from "../../../assets/icons/show.svg";
import { ReactComponent as SquadsIcon } from "../../../assets/icons/squads.svg";
import { ReactComponent as StarIcon } from "../../../assets/icons/star.svg";
import { ReactComponent as StarGradientIcon } from "../../../assets/icons/star_gradient.svg";
import { ReactComponent as BronzeStarIcon } from "../../../assets/icons/stars/bronze_star.svg";
import { ReactComponent as GoldStarIcon } from "../../../assets/icons/stars/gold_star.svg";
import { ReactComponent as SilverStarIcon } from "../../../assets/icons/stars/silver_star.svg";
import { ReactComponent as StarsGroup } from "../../../assets/icons/stars_group.svg";
import { ReactComponent as StepsIcon } from "../../../assets/icons/steps.svg";
import { ReactComponent as StopIcon } from "../../../assets/icons/stop.svg";
import { ReactComponent as StudentIcon } from "../../../assets/icons/student.svg";
import { ReactComponent as TodoListIcon } from "../../../assets/icons/todo_list.svg";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trash.svg";
import { ReactComponent as UnlockIcon } from "../../../assets/icons/unlock.svg";
import { ReactComponent as UpChevronIcon } from "../../../assets/icons/up_chevron.svg";
import { ReactComponent as UploadIcon } from "../../../assets/icons/upload.svg";
import { ReactComponent as UploadToCloudIcon } from "../../../assets/icons/upload_to_cloud.svg";
import { ReactComponent as UserIcon } from "../../../assets/icons/user.svg";
import { ReactComponent as VideoPlaceholderIcon } from "../../../assets/icons/video_placeholder.svg";
import { ReactComponent as VisibleIcon } from "../../../assets/icons/visible.svg";
import { ReactComponent as VolumnUpIcon } from "../../../assets/icons/volumn_up.svg";
import { ReactComponent as WarningIcon } from "../../../assets/icons/warning.svg";
import { ReactComponent as WritingIcon } from "../../../assets/icons/writing.svg";
import { ReactComponent as LogoIcon1 } from "../../../assets/logo1.svg";
import { ReactComponent as LogoIcon2 } from "../../../assets/logo2.svg";
import { ReactComponent as LogoIcon3 } from "../../../assets/logo3.svg";
import { ReactComponent as LogoIcon4 } from "../../../assets/logo4.svg";
import { ReactComponent as DefaultAvatar } from "../../../assets/squad/default_avatar.svg";
import { ReactComponent as FirstSquad } from "../../../assets/squad/first_squad.svg";
import { ReactComponent as SecondSquad } from "../../../assets/squad/second_squad.svg";
import { ReactComponent as ThirdSquad } from "../../../assets/squad/third_squad.svg";

const iconComponents = {
  astronaut: AstronautIcon,
  home: HomeIcon,
  bookmark: BookmarkIcon,
  bookmarks: BookmarksIcon,
  bookmarkEarned: BookmarkEarnedIcon,
  calendar: CalendarIcon,
  celebration: CelebrationIcon,
  challenge: ChallengeIcon,
  check: CheckIcon,
  check1: Check1Icon,
  checkList: CheckListIcon,
  checkProgress: CheckProgressIcon,
  checkError: CheckErrorIcon,
  close: CloseIcon,
  closeType1: CloseType1Icon,
  circle: CircleIcon,
  destination: DestinationIcon,
  starsGroup: StarsGroup,
  direction: DirectionIcon,
  downChevron: DownChevronIcon,
  download: DownloadIcon,
  documentReview: DocumentReviewIcon,
  fastforward: FastforwardIcon,
  // filter: FilterIcon,
  openSeason: OpenSeason,
  journeyAvatar: JourneyAvatar,
  closeSeason: CloseSeason,
  hide: HideIcon,
  invisible: InvisibleIcon,
  leftChevron: LeftChevronIcon,
  levelRecap: LevelRecapIcon,
  leftArrow: LeftArrow,
  levelObject: LevelObject,
  lesson: LessonIcon,
  logoIcon1: LogoIcon1,
  logoIcon2: LogoIcon2,
  logoIcon3: LogoIcon3,
  logoIcon4: LogoIcon4,
  levelProgressReport: LevelProgressReportIcon,
  levelDeliverable: LevelDeliverableIcon,
  link: LinkIcon,
  lowVolumn: LowVolumnIcon,
  magicWand: MagicWandIcon,
  maximize: MaximizeIcon,
  mirror: MirrorIcon,
  mute: MuteIcon,
  next: NextIcon,
  notification: NotificationIcon,
  padlock: PadlockIcon,
  padlockUnlock: PadlockUnlock,
  performance: PerformanceIcon,
  pause: PauseIcon,
  pen: PenIcon,
  picturePlaceholder: PicturePlaceholderIcon,
  play: PlayIcon,
  podium: PodiumIcon,
  previous: PreviousIcon,
  process: ProcessIcon,
  provideFeedback: ProvideFeedbackIcon,
  question: QuestionIcon,
  pending: PendingIcon,
  rating: RatingIcon,
  refresh: RefreshIcon,
  rewind: RewindIcon,
  rightChevron: RightChevronIcon,
  search: SearchIcon,
  sendMail: SendMailIcon,
  settings: SettingsIcon,
  show: ShowIcon,
  share: Share,
  starGradient: StarGradientIcon,
  star: StarIcon,
  steps: StepsIcon,
  student: StudentIcon,
  squads: SquadsIcon,
  stop: StopIcon,
  todoList: TodoListIcon,
  trash: TrashIcon,
  unlock: UnlockIcon,
  upChevron: UpChevronIcon,
  upload: UploadIcon,
  uploadToCloud: UploadToCloudIcon,
  user: UserIcon,
  videoPlaceholder: VideoPlaceholderIcon,
  visible: VisibleIcon,
  volumnUp: VolumnUpIcon,
  warning: WarningIcon,
  writing: WritingIcon,
  defaultAvatar: DefaultAvatar,
  firstPosition: FirstSquad,
  secondPosition: SecondSquad,
  thirdPosition: ThirdSquad,
  rightArrowRed: RightArrowRedIcon,
  rightArrowWhite: RightArrowWhiteIcon,

  goldStar: GoldStarIcon,
  silverStar: SilverStarIcon,
  bronzeStar: BronzeStarIcon,

  csv: CSVIcon,
  pdf: PDFIcon,
  ppt: PPTIcon,
  xsl: XSLIcon,
  docx: DOCXIcon,
  mpeg: MPEGIcon,
  mp4: MP4Icon,
};

const Icons = (props) => {
  const { type, color, ...rest } = props;
  const IconComponent = iconComponents[type];
  const svgRef = useRef(null);

  useEffect(() => {
    if (svgRef.current && color) {
      const paths = svgRef.current.querySelectorAll("path");
      paths.forEach((path) => {
        path.style.fill = color;
        if (
          type === "levelObject" ||
          type === "upChevron" ||
          type === "levelProgressReport" ||
          type === "levelDeliverable" ||
          type === "link"
        ) {
          path.style.stroke = color;
        }
      });
    }
  }, [color, type]);

  if (!IconComponent) {
    console.warn(`Icon type ${type} not found`);
    return null;
  }

  return <IconComponent {...rest} ref={svgRef} />;
};

Icons.propTypes = {
  type: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default Icons;
